import Add from "./Add";
import Analytics from "./Analytics";
import Apps from "./Apps";
import ArrowDown from "./ArrowDown";
import ArrowDropdown from "./ArrowDropdown";
import ArrowDropright from "./ArrowDropright";
import ArrowDropup from "./ArrowDropup";
import ArrowLeft from "./ArrowLeft";
import ArrowOutward from "./ArrowOutward";
import ArrowRight from "./ArrowRight";
import ArrowUp from "./ArrowUp";
import Assistant from "./Assistant";
import AttachFile from "./AttachFile";
import Basket from "./Basket";
import Calendar from "./Calendar";
import Cancel from "./Cancel";
import CardMembership from "./CardMembership";
import ChangeCircle from "./ChangeCircle";
import Checkmark from "./CheckMark";
import CheckmarkCircle from "./CheckmarkCircle";
import ChevronDown from "./ChevronDown";
import ChevronLeft from "./ChevronLeft";
import ChevronRight from "./ChevronRight";
import ChevronUp from "./ChevronUp";
import Close from "./Close";
import Code from "./Code";
import Copy from "./Copy";
import Dangerous from "./Dangerous";
import Dashboard from "./Dashboard";
import Deactivate from "./Deactivate";
import Delete from "./Delete";
import Disturb from "./Disturb";
import Dollar from "./Dollar";
import DragIndicator from "./DragIndicator";
import Edit from "./Edit";
import EditSquare from "./EditSquare";
import Error from "./Error";
import Export from "./Export";
import FileUpload from "./FileUpload";
import Filter from "./Filter";
import FilterList from "./FilterList";
import Folder from "./Folder";
import FolderCreate from "./FolderCreate";
import Graph from "./Graph";
import Help from "./Help";
import History from "./History";
import Home from "./Home";
import HorizontalRule from "./HorizontalRule";
import ImagesMode from "./ImagesMode";
import Import from "./Import";
import Info from "./Info";
import InfoOutlined from "./InfoOutlined";
import Input from "./Input";
import Integrate from "./Integrate";
import Inventory from "./Inventory";
import Kebab from "./Kebab";
import Label from "./Label";
import Launch from "./Launch";
import List from "./List";
import Location from "./Location";
import LocationAdd from "./LocationAdd";
import Lock from "./Lock";
import LowPriority from "./LowPriority";
import Loyalty from "./Loyalty";
import Menu from "./Menu";
import Merge from "./Merge";
import Monitoring from "./Monitoring";
import More from "./More";
import OpenInNew from "./OpenInNew";
import Organization from "./Organization";
import Payments from "./Payments";
import Percent from "./Percent";
import PersonAdd from "./PersonAdd";
import PersonOff from "./PersonOff";
import Phone from "./Phone";
import Print from "./Print";
import Product from "./Product";
import Profile from "./Profile";
import ProfileGroup from "./ProfileGroup";
import ProfileGroupOff from "./ProfileGroupOff";
import Public from "./Public";
import PublicOff from "./PublicOff";
import ReceiptLong from "./ReceiptLong";
import Redeem from "./Redeem";
import Release from "./Release";
import Remove from "./Remove";
import Restart from "./Restart";
import Revoke from "./Revoke";
import Roles from "./Roles";
import Scan from "./Scan";
import Schedule from "./Schedule";
import Search from "./Search";
import Settings from "./Settings";
import ShoppingCart from "./ShoppingCart";
import Signout from "./Signout";
import Store from "./Store";
import Success from "./Success";
import Sync from "./Sync";
import Tag from "./Tag";
import Task from "./Task";
import TrendingDown from "./TrendingDown";
import TrendingUp from "./TrendingUp";
import UnfoldLess from "./UnfoldLess";
import UnfoldMore from "./UnfoldMore";
import Unlock from "./Unlock";
import Users from "./Users";
import ViewColumn from "./ViewColumn";
import VisibilityOff from "./VisibilityOff";
import VisibilityOn from "./VisibilityOn";
import Warning from "./Warning";
export const materialSymbolsIcons = {
    Add,
    Analytics,
    Apps,
    ArrowDown,
    ArrowDropdown,
    ArrowDropright,
    ArrowDropup,
    ArrowLeft,
    ArrowOutward,
    ArrowRight,
    ArrowUp,
    Assistant,
    AttachFile,
    Basket,
    Calendar,
    Cancel,
    CardMembership,
    ChangeCircle,
    Checkmark,
    CheckmarkCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Close,
    Code,
    Copy,
    Dangerous,
    Dashboard,
    Deactivate,
    Delete,
    Disturb,
    Dollar,
    DragIndicator,
    Edit,
    EditSquare,
    Error,
    Export,
    FileUpload,
    Filter,
    FilterList,
    Folder,
    FolderCreate,
    Graph,
    Help,
    History,
    Home,
    HorizontalRule,
    ImagesMode,
    Import,
    Info,
    InfoOutlined,
    Input,
    Integrate,
    Inventory,
    Kebab,
    Label,
    Launch,
    List,
    Location,
    LocationAdd,
    Lock,
    LowPriority,
    Loyalty,
    Menu,
    Merge,
    Monitoring,
    More,
    OpenInNew,
    Organization,
    Payments,
    Percent,
    PersonAdd,
    PersonOff,
    Phone,
    Print,
    Product,
    Profile,
    ProfileGroup,
    ProfileGroupOff,
    Public,
    PublicOff,
    ReceiptLong,
    Redeem,
    Release,
    Remove,
    Restart,
    Revoke,
    Roles,
    Scan,
    Schedule,
    Search,
    Settings,
    ShoppingCart,
    Signout,
    Store,
    Success,
    Sync,
    Tag,
    Task,
    TrendingDown,
    TrendingUp,
    UnfoldLess,
    UnfoldMore,
    Unlock,
    Users,
    ViewColumn,
    VisibilityOff,
    VisibilityOn,
    Warning,
};
